import React from "react";
import {Header} from "./Header";
import {Sidebar} from "./Sidebar";
import {getUserToken, isLoggedIn, logout} from "../controller/AuthService";
import {Config} from "../controller/Global";
import {apiMethods} from "../controller/Request";
import {ServerMaintenance} from "./ServerMaintenance";
import * as Sentry from '@sentry/browser';
import {getEnvValue} from "../controller/Environment";
import {UserContext} from "../controller/Utils";

Sentry.init({
  dsn: getEnvValue('SENTRY_DNS')
});

export class Main extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      user: {}
    };
  }

  componentDidCatch(error, info) {
    this.setState({hasError: true});
    Sentry.withScope(scope => {
      Object.keys(info).forEach(key => {
        scope.setExtra(key, info[key]);
      });
      Sentry.captureException(error);
    });
  }

  getUser = () => {
    const URL = Config['api']['auth']['profile'];
    apiMethods.get(URL, {}, true)
      .then(response => {
        this.setState({user: response.data});
      });
  }

  componentDidMount() {
    if (!isLoggedIn())
      return logout();
    this.getUser()
  }

  componentDidUpdate(prevProps) {
    const {user} = this.state;
    const token = getUserToken();
    if (token && user.token !== token) {
      this.getUser()
    }
  }

  render() {
    const {user, hasError} = this.state;
    if (isLoggedIn()) {
      const {children} = this.props;
      const childrenWithProps = React.Children.map(children, child =>
        React.cloneElement(child) // For pass user in React.cloneElement(child, {user: user})
      );
      return (
        <div id="shell">
          <Header user={user}/>
          <Sidebar user={user}/>
          {hasError? <ServerMaintenance/>: <UserContext.Provider value={this.state}>{childrenWithProps}</UserContext.Provider>}
        </div>
      )}
    else
      return (<div/>)
  }
}



// WEBPACK FOOTER //
// ./src/pages/Main.jsx